
var map = null;
var bounds = new google.maps.LatLngBounds();
var markersArray = [];

function GoogleMapsInitialize(id, center, zoom) {
    var latitude = center.substring(0, center.indexOf(","));
    var longitude = center.substring(center.indexOf(",") + 1);

    var myOptions = {
        center: new google.maps.LatLng(latitude, longitude),
        zoom: zoom,
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: true,
        scaleControl: true,
        overviewMapControlOptions: {
            opened: true
        }
    };

    // define map
    map = new google.maps.Map(document.getElementById(id), myOptions);

    if (center != undefined && center.length > 0) {
        google.maps.event.addListenerOnce(map, 'idle', function () {
            $('#ne').val(bounds.getNorthEast().lat() + ',' + bounds.getNorthEast().lng());
            $('#sw').val(bounds.getSouthWest().lat() + ',' + bounds.getSouthWest().lng());
        });
    }
}

function FitAndZoomMap(zoom) {
    mgr = new MarkerManager(map);

    google.maps.event.addDomListener(mgr, 'loaded', function () {
       
        if (markersArray.length == 1) {//zoom out only when 1 dealer found
            map.setCenter(markersArray[0].position);
            map.setZoom(15);
        } else {
            map.setZoom(1);
            map.fitBounds(bounds);
            // SK: one dealer with zoom 19+ was too zoomed in
            if (map.getZoom() > 18) {
                map.setZoom(18);
            }

        }
    });

}

function AddMarker(dealerId, latitude, longitude, title, index, markerFileName, id) {

    //console.log("addmarker");

    var latLng = new google.maps.LatLng(latitude, longitude);
    var iconHeight = 40;
    if (markerFileName == "Marker-InStoreNow.png") {
        iconHeight = 70;
    }
    var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: title,
        icon: {
            url: cdn + "/Images/Shared/Stores/" + markerFileName,
            size: new google.maps.Size(70, iconHeight)
        }
    });

    var html = '';
    if (id != undefined) {
        html = $("#googleMapsMarkerInfo-" + id).html();
    }

    //console.log("id: " + id);

    marker.info = new google.maps.InfoWindow({
        maxWidth: 450,
        content: html
    });

    google.maps.event.addListener(marker, 'click', function () {
        if (activeGoogleMapsInfoWindow) {
            activeGoogleMapsInfoWindow.close();
        }
        activeGoogleMapsInfoWindow = marker.info;
        marker.info.open(map, marker);
    });

    markersArray[index] = marker;

    //Extends bounds to contain the given point
    bounds.extend(latLng);

    return marker;
}

function ToggleDirectionsToDealer(dealerId) {
    var dealerinfo = document.getElementById("dealerinfo-" + dealerId);
    var directions = document.getElementById("directions-" + dealerId);

    // <=IE9 does not support contains() or classList.add()!
    if (dealerinfo.className.indexOf("hidden") > -1) {
        dealerinfo.className = "";
    }
    else {
        dealerinfo.className = "hidden";
    }
    if (directions.className.indexOf("hidden") > -1) {
        directions.className = "";
    }
    else {
        directions.className = "hidden";
    }
}